<irembogov-editable-input
  [customFormControl]="formControl"
  [id]="field.key"
  [placeholder]="field.props.placeholder ? field.props.placeholder : ''"
  [label]="field.props['label']"
  [inputType]="field.props['inputType'] || 'text'"
  [textType]="field.props['textType'] || 'text'"
  [minNumber]="field.props['minNumber']"
  [maxNumber]="field.props['maxNumber']"
  [minLength]="field.props['minLength']"
  [maxLength]="field.props['maxLength']"
  [pattern]="field.props['pattern']"
  [initialValue]="field.props['initialValue']"
  [dateFormat]="field.props['dateFormat'] || 'DD MM YYYY'"
  [minDate]="field.props['minDate'] || { year: 1900, month: 1, day: 1 }"
  [maxDate]="field.props['maxDate'] || { year: 2100, month: 12, day: 31 }"
  [delimiter]="field.props['delimiter'] || '/'"
  [addRemoveTimeMinDate]="field.props['addRemoveTimeMinDate']"
  [addRemoveTimeMaxDate]="field.props['addRemoveTimeMaxDate']"
  [items]="field.props['options'] || field.props['items'] || items || []"
  [bindLabel]="field.props['bindLabel'] || 'label'"
  [bindValue]="field.props['bindValue'] || 'value'"
  [multiple]="field.props['multiple'] || false"
  (valueChange)="onValueChange($event)">
</irembogov-editable-input>
